import React from 'react';
import { buildURL, SharedImigixAndSourceProps } from 'react-imgix';

import { useConfig } from 'ha/helpers/config';

type TransformImageURL = (
  src: string,
  params?: SharedImigixAndSourceProps['imgixParams'],
) => string;
interface UseImgixResponse {
  transformImageURL: TransformImageURL;
}

const removeQueryString = (src: string): string => src.split('?')[0];

const replaceBoschImageType = (boschType: string): string => {
  const typeReplaceList = {
    listing: 'room',
    unilogo: 'uni_logo',
    uniphoto: 'uni_photo',
    user: 'hauser',
  };
  return typeReplaceList[boschType];
};

const useImgix = (): UseImgixResponse => {
  const { imgix } = useConfig();
  const transformImageURL: TransformImageURL = React.useCallback(
    (src, params) => {
      const boschURLPattern =
        /.*housinganywhere\.com\/images\/(?<type>listing|unilogo|uniphoto|user)\/(?<ownerId>\d+)\/(?:default|raw|\d+x\d+)\/(?<uuid>[0-9a-f-]+)/i;
      if (boschURLPattern.test(src)) {
        return buildURL(
          removeQueryString(src).replace(boschURLPattern, (...matches) => {
            const namedMatches = matches[matches.length - 1];
            const type = replaceBoschImageType(namedMatches.type);
            return `${imgix.sourceURL}/${type}/${namedMatches.ownerId}/${namedMatches.uuid}.jpg`;
          }),
          params,
        );
      }
      return buildURL(
        removeQueryString(src).replace(
          /.*housinganywhere.com(?:\/v2)?\/images\//,
          `${imgix.sourceURL}/`,
        ),
        params,
      );
    },
    [imgix],
  );
  const response = React.useMemo(
    () => ({ transformImageURL }),
    [transformImageURL],
  );
  return response;
};

export default useImgix;
